export default function () {
  return {
    recent: [],
    list: [],
    system: null // id of the system the current list was fetched for
  }
}
